var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-title"},[_c('div',{staticClass:"menu-title_body"},[_c('h1',[_vm._t("default")],2)]),_vm._v(" "),(_vm.img)?_c('div',{staticClass:"menu-title_img"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }